import Slider from "react-slick";
import React from 'react';

export default function HomeLogos() {
  const logos = [
    { image: "/assets/images/new-client-logo1.webp", title: "Brand 1" },
    { image: "/assets/images/new-client-logo2.webp", title: "Brand 2" },
    { image: "/assets/images/new-client-logo3.webp", title: "Brand 3" },
    { image: "/assets/images/new-client-logo4.webp", title: "Brand 4" },
    { image: "/assets/images/new-client-logo5.webp", title: "Brand 5" },
    { image: "/assets/images/new-client-logo6.webp", title: "Brand 6" },
    { image: "/assets/images/new-client-logo7.webp", title: "Brand 7" },
    { image: "/assets/images/new-client-logo8.webp", title: "Brand 8" },
    { image: "/assets/images/new-client-logo9.webp", title: "Brand 9" },
    { image: "/assets/images/new-client-logo10.webp", title: "Brand 10" },
    { image: "/assets/images/new-client-logo11.webp", title: "Brand 11" },
    { image: "/assets/images/new-client-logo12.webp", title: "Brand 12" },
    { image: "/assets/images/new-client-logo13.webp", title: "Brand 13" },
    { image: "/assets/images/new-client-logo14.webp", title: "Brand 14" },
  ];

  const settingslogos = {
    dots: false,
    slidesToShow: 9,
    infinite: true,
    autoplay: true,
    slidesToScroll: 1,
    pauseOnHover: false,
    arrows: false,
    cssEase: "linear",
    autoplaySpeed: 0,
    initialSlide: 0,
    speed: 4000,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 599,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  };

  return (
    <section className="home-patner space">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-12 col-lg-9">
            <h4 className="heading center-heading">
              Trusted by global manufacturers, <br /> retailers, and distributors
            </h4>
          </div>
        </div>
      </div>

      <Slider {...settingslogos} className="home-brand-slider">
        {logos.map((logo, index) => (
          <div className="homepartner-box" key={index}>
            <div className="partner-inner">
              <img
                src={logo.image}
                alt={logo.title}
                className="img-responsive"
              />
            </div>
          </div>
        ))}
      </Slider>
    </section>
  );
}
